module.exports = __webpack_public_path__ + "img/organigramme-anglais.502f576f.png";